import uniqueId from 'lodash/uniqueId'

export function generateId(length = 5) {
  const chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
  let result = ''
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length))
  }
  return result
}

export function generateChatRef(clientId: string | null, type: string) {
  const reqId = uniqueId()
  return `${clientId}-${type}-${reqId}`
}
